<!--
/**
* @name: YButton.vue
* @description: 图标按钮
* @author: 于海威
* @create: 2020/07/28 15:26:54
* @update: 2020/07/28 15:26:54
*/
-->

<script>
export default {
  props: {
    icon: { // 图标的iconfont定义名称
      type: String
    },
    size: { // 图标大小
      type: [Number, String],
      default: 14
    },
    buttonType: { // 按钮样式，参考k-button
      type: String,
      default: 'primary'
    }
  },
  render() {
    const {
      buttonType, icon, size, $slots, $listeners
    } = this;
    const buttonListeners = {
      on: {
        ...$listeners
      }
    };
    let iconNode = null;
    if (icon) {
      iconNode = <span><k-icon name={icon} size={size} />&nbsp;</span>;
    }
    return (
      <k-button type={buttonType} {...buttonListeners}>
        {iconNode}{$slots.default}
      </k-button>
    );
  }
};
</script>
